import type { ManifestLocalization } from './extensions/localization.extension.js';

export const manifests: Array<ManifestLocalization> = [
	{
		type: 'localization',
		alias: 'Umb.Localization.AR',
		name: 'Arabic Backoffice UI Localization',
		meta: { culture: 'ar' },
		js: () => import('../../../assets/lang/ar.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.BS',
		name: 'Bosnian Backoffice UI Localization',
		meta: { culture: 'bs' },
		js: () => import('../../../assets/lang/bs.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.CS',
		name: 'Czech Backoffice UI Localization',
		meta: { culture: 'cs' },
		js: () => import('../../../assets/lang/cs.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.CS_CZ',
		name: 'Czech (Czechia) Backoffice UI Localization',
		meta: { culture: 'cs-CZ' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.CY',
		name: 'Welsh Backoffice UI Localization',
		meta: { culture: 'cy' },
		js: () => import('../../../assets/lang/cy.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.CY_GB',
		name: 'Welsh (UK) Backoffice UI Localization',
		meta: { culture: 'cy-GB' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.DA',
		name: 'Danish Backoffice UI Localization',
		meta: { culture: 'da' },
		js: () => import('../../../assets/lang/da.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.DA-DK',
		name: 'Danish (Denmark) Backoffice UI Localization',
		meta: { culture: 'da-DK' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.DE',
		name: 'German Backoffice UI Localization',
		meta: { culture: 'de' },
		js: () => import('../../../assets/lang/de.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.DE_DE',
		name: 'German (Germany) Backoffice UI Localization',
		meta: { culture: 'de-DE' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.DE_CH',
		name: 'German (Switzerland) Backoffice UI Localization',
		meta: { culture: 'de-CH' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.EN',
		name: 'English (United Kingdom) Backoffice UI Localization',
		meta: { culture: 'en' },
		js: () => import('../../../assets/lang/en.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.EN_US',
		name: 'English (United States) Backoffice UI Localization',
		meta: { culture: 'en-US' },
		js: () => import('../../../assets/lang/en-us.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.ES',
		name: 'Spanish Backoffice UI Localization',
		meta: { culture: 'es' },
		js: () => import('../../../assets/lang/es.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.ES_ES',
		name: 'Spanish (Spain) Backoffice UI Localization',
		meta: { culture: 'es-ES' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.FR',
		name: 'French Backoffice UI Localization',
		meta: { culture: 'fr' },
		js: () => import('../../../assets/lang/fr.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.FR_FR',
		name: 'French (France) Backoffice UI Localization',
		meta: { culture: 'fr-FR' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.FR_CH',
		name: 'French (Switzerland) Backoffice UI Localization',
		meta: { culture: 'fr-CH' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.HE',
		name: 'Hebrew Backoffice UI Localization',
		meta: { culture: 'he' },
		js: () => import('../../../assets/lang/he.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.HE_IL',
		name: 'Hebrew (Israel) Backoffice UI Localization',
		meta: { culture: 'he-IL' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.HR',
		name: 'Croatian Backoffice UI Localization',
		meta: { culture: 'hr' },
		js: () => import('../../../assets/lang/hr.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.HR_HR',
		name: 'Croatian (Croatia) Backoffice UI Localization',
		meta: { culture: 'hr-HR' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.IT',
		name: 'Italian Backoffice UI Localization',
		meta: { culture: 'it' },
		js: () => import('../../../assets/lang/it.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.IT_IT',
		name: 'Italian (Italy) Backoffice UI Localization',
		meta: { culture: 'it-IT' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.IT_CH',
		name: 'Italian (Switzerland) Backoffice UI Localization',
		meta: { culture: 'it-CH' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.JA',
		name: 'Japanese Backoffice UI Localization',
		meta: { culture: 'ja' },
		js: () => import('../../../assets/lang/ja.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.JA_JP',
		name: 'Japanese (Japan) Backoffice UI Localization',
		meta: { culture: 'ja-JP' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.KO',
		name: 'Korean Backoffice UI Localization',
		meta: { culture: 'ko' },
		js: () => import('../../../assets/lang/ko.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.KO_KR',
		name: 'Korean (Korea) Backoffice UI Localization',
		meta: { culture: 'ko-KR' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.NB',
		name: 'Norwegian Backoffice UI Localization',
		meta: { culture: 'nb' },
		js: () => import('../../../assets/lang/nb.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.NB_NO',
		name: 'Norwegian (Norway) Backoffice UI Localization',
		meta: { culture: 'nb-NO' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.NL',
		name: 'Dutch Backoffice UI Localization',
		meta: { culture: 'nl' },
		js: () => import('../../../assets/lang/nl.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.NL_NL',
		name: 'Dutch (Netherlands) Backoffice UI Localization',
		meta: { culture: 'nl-NL' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.PL',
		name: 'Polish Backoffice UI Localization',
		meta: { culture: 'pl' },
		js: () => import('../../../assets/lang/pl.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.PL_PL',
		name: 'Polish (Poland) Backoffice UI Localization',
		meta: { culture: 'pl-PL' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.PT',
		name: 'Portuguese Backoffice UI Localization',
		meta: { culture: 'pt' },
		js: () => import('../../../assets/lang/pt.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.PT_BR',
		name: 'Portuguese (Brazil) Backoffice UI Localization',
		meta: { culture: 'pt-BR' },
		js: () => import('../../../assets/lang/pt-br.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.RO',
		name: 'Romanian Backoffice UI Localization',
		meta: { culture: 'ro' },
		js: () => import('../../../assets/lang/ro.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.RO_RO',
		name: 'Romanian (Romania) Backoffice UI Localization',
		meta: { culture: 'ro-RO' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.RU',
		name: 'Russian Backoffice UI Localization',
		meta: { culture: 'ru' },
		js: () => import('../../../assets/lang/ru.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.RU_RU',
		name: 'Russian (Russia) Backoffice UI Localization',
		meta: { culture: 'ru-RU' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.SV',
		name: 'Swedish Backoffice UI Localization',
		meta: { culture: 'sv' },
		js: () => import('../../../assets/lang/sv.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.SV_SE',
		name: 'Swedish (Sweden) Backoffice UI Localization',
		meta: { culture: 'sv-SE' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.TR',
		name: 'Turkish Backoffice UI Localization',
		meta: { culture: 'tr' },
		js: () => import('../../../assets/lang/tr.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.TR_TR',
		name: 'Turkish (Türkiye) Backoffice UI Localization',
		meta: { culture: 'tr-TR' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.UK',
		name: 'Ukrainian Backoffice UI Localization',
		meta: { culture: 'uk' },
		js: () => import('../../../assets/lang/uk.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.UK_UA',
		name: 'Ukrainian (Ukraine) Backoffice UI Localization',
		meta: { culture: 'uk-UA' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.ZH',
		name: 'Chinese Backoffice UI Localization',
		meta: { culture: 'zh' },
		js: () => import('../../../assets/lang/zh.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.ZH_CN',
		name: 'Chinese (Simplified, China) Backoffice UI Localization',
		meta: { culture: 'zh-CN' },
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.ZH_TW',
		name: 'Chinese (Taiwan) Backoffice UI Localization',
		meta: { culture: 'zh-TW' },
		js: () => import('../../../assets/lang/zh-tw.js'),
	},
	{
		type: 'localization',
		alias: 'Umb.Localization.VI',
		name: 'Vietnamese Backoffice UI Localization',
		meta: { culture: 'vi' },
		js: () => import('../../../assets/lang/vi.js'),
	},
];
